import { render, staticRenderFns } from "./WsDashboard.vue?vue&type=template&id=2122db40&"
import script from "./WsDashboard.vue?vue&type=script&lang=js&"
export * from "./WsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports